if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
// Enhanced lightbox with navigation - SAFE mobile prevention
window.addEventListener('load', function () {
  // Simple and reliable mobile detection
  function isMobileDevice() {
    return window.innerWidth <= 768 || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  }
  
  const isDesktop = () => !isMobileDevice();
  
  let currentImageIndex = 0;
  let allImages = [];
  
  // Function to collect all current product images
  function updateImageCollection() {
    allImages = [];
    const mediaImages = document.querySelectorAll('.product__modal-opener--image');
    
    mediaImages.forEach((opener, index) => {
      const img = opener.querySelector('img');
      if (!img) return;
      
      allImages.push({
        src: img.src.replace('_small', '').replace('_medium', '').replace('_large', ''),
        alt: img.alt || `Product image ${index + 1}`,
        element: opener
      });
      
      // Only remove href attribute, leave everything else intact
      opener.removeAttribute('href');
      
      // Set cursor based on device
      if (isDesktop()) {
        opener.style.cursor = 'pointer';
      } else {
        opener.style.cursor = 'default';
      }
    });
  }

  // Make function globally accessible for additional integrations
  window.updateImageCollection = updateImageCollection;
  
  // Initial image collection
  updateImageCollection();
  
  // Use event delegation - but with strict mobile blocking
  document.addEventListener('click', function(e) {
    // STRICT mobile check - exit immediately
    if (isMobileDevice()) {
      // On mobile, if it's a product image, prevent any action
      const opener = e.target.closest('.product__modal-opener--image');
      if (opener) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        return false;
      }
      return; // Let other clicks work normally on mobile
    }
    
    // Desktop only behavior below
    const opener = e.target.closest('.product__modal-opener--image');
    if (!opener) return;
    
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    
    // Update image collection in case variants were switched
    updateImageCollection();
    
    // Find the index of the clicked image
    currentImageIndex = allImages.findIndex(img => img.element === opener);
    if (currentImageIndex === -1) currentImageIndex = 0;
    
    openLightbox();
  }, true);
  
  function openLightbox() {
    // Safety check
    if (isMobileDevice()) {
      return;
    }
    
    // Close any existing lightboxes first
    const existingLightbox = document.querySelector('.custom-lightbox');
    if (existingLightbox) existingLightbox.remove();
    
    // Create enhanced lightbox with navigation
    const lightbox = document.createElement('div');
    lightbox.className = 'custom-lightbox';
    lightbox.innerHTML = `
      <div class="lightbox-content">
        <button class="lightbox-nav lightbox-prev" ${allImages.length <= 1 ? 'style="display:none"' : ''}>‹</button>
        <div class="lightbox-image-container">
          <img src="${allImages[currentImageIndex].src}" alt="${allImages[currentImageIndex].alt}" onload="this.style.opacity=1">
          <div class="lightbox-counter">${currentImageIndex + 1} / ${allImages.length}</div>
        </div>
        <button class="lightbox-nav lightbox-next" ${allImages.length <= 1 ? 'style="display:none"' : ''}>›</button>
        <button class="lightbox-close">&times;</button>
      </div>
    `;

    document.body.appendChild(lightbox);
    document.body.style.overflow = 'hidden';
      
    // Navigation functions
    function showImage(index) {
      const img = lightbox.querySelector('.lightbox-image-container img');
      const counter = lightbox.querySelector('.lightbox-counter');
      
      img.style.opacity = '0';
      setTimeout(() => {
        img.src = allImages[index].src;
        img.alt = allImages[index].alt;
        counter.textContent = `${index + 1} / ${allImages.length}`;
      }, 150);
    }
    
    function nextImage() {
      currentImageIndex = (currentImageIndex + 1) % allImages.length;
      showImage(currentImageIndex);
    }
    
    function prevImage() {
      currentImageIndex = (currentImageIndex - 1 + allImages.length) % allImages.length;
      showImage(currentImageIndex);
    }
    
    function closeLightbox() {
      const lightbox = document.querySelector('.custom-lightbox');
      if (lightbox) {
        lightbox.remove();
        document.body.style.overflow = '';
        // Remove the keydown listener
        document.removeEventListener('keydown', keyHandler);
      }
    }
    
    // Keyboard navigation handler
    function keyHandler(e) {
      if (e.key === 'Escape') {
        closeLightbox();
      } else if (e.key === 'ArrowRight') {
        nextImage();
      } else if (e.key === 'ArrowLeft') {
        prevImage();
      }
    }
    
    // Event listeners
    lightbox.querySelector('.lightbox-next')?.addEventListener('click', nextImage);
    lightbox.querySelector('.lightbox-prev')?.addEventListener('click', prevImage);
    lightbox.querySelector('.lightbox-close')?.addEventListener('click', closeLightbox);
    
    // Close on backdrop click
    lightbox.addEventListener('click', (e) => {
      if (e.target === lightbox) {
        closeLightbox();
      }
    });
    
    // Keyboard navigation
    document.addEventListener('keydown', keyHandler);
  }

  // Listen for variant changes to update image collection
  document.addEventListener('variant:change', function() {
    setTimeout(updateImageCollection, 100);
  });
  
  // Also listen for any DOM changes in the media gallery area
  const observer = new MutationObserver(function(mutations) {
    let shouldUpdate = false;
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList') {
        // Check if any added/removed nodes contain product images
        const addedImages = Array.from(mutation.addedNodes).some(node => 
          node.nodeType === 1 && (
            node.classList?.contains('product__modal-opener--image') ||
            node.querySelector?.('.product__modal-opener--image')
          )
        );
        const removedImages = Array.from(mutation.removedNodes).some(node => 
          node.nodeType === 1 && (
            node.classList?.contains('product__modal-opener--image') ||
            node.querySelector?.('.product__modal-opener--image')
          )
        );
        if (addedImages || removedImages) {
          shouldUpdate = true;
        }
      }
    });
    
    if (shouldUpdate) {
      setTimeout(updateImageCollection, 50);
    }
  });
  
  // Observe the product media gallery for changes
  const mediaGallery = document.querySelector('media-gallery') || document.querySelector('.product__media-gallery');
  if (mediaGallery) {
    observer.observe(mediaGallery, {
      childList: true,
      subtree: true
    });
  }

  // Window resize handler
  window.addEventListener('resize', function() {
    if (isMobileDevice()) {
      const lightbox = document.querySelector('.custom-lightbox');
      if (lightbox) {
        lightbox.remove();
        document.body.style.overflow = '';
      }
    }
  });
});